/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconScubaDiving = createReactComponent("scuba-diving", "IconScubaDiving", [
  ["path", { d: "M19 12a1 1 0 1 0 2 0a1 1 0 0 0 -2 0", key: "svg-0" }],
  ["path", { d: "M2 2l3 3l1.5 4l3.5 2l6 2l1 4l2.5 3", key: "svg-1" }],
  ["path", { d: "M11 8l4.5 1.5", key: "svg-2" }]
]);

export { IconScubaDiving as default };
//# sourceMappingURL=IconScubaDiving.js.map
